import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./SelectTime.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../../Styleds";
import styled from "styled-components";
const hours = Array.from({ length: 24 }, (_, i) => (i).toString().padStart(2, '0'));
// 生成 00 到 55 的分钟数组，每隔 5 分钟
const minutes = Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, '0'));
export const TimeDiv = styled.div`
                scroll-snap-align: start;
                height: ${props => props.height}px;
                min-height: ${props => props.height}px;
                max-height: ${props => props.height}px;
                display: flex;
                justify-content: center;
                align-items: center;
`;
const SelectTime = ({ initHr=0,initMin=0,onSelect=()=>{}, onChangedHr=()=>{}, onChangedMin=()=>{} }) => {
    const timeHeight = 35;
    const [hr, set_hr] = useState("00");
    const [min, set_min] = useState("00");
    const hrRef=useRef(null);
    const minRef=useRef(null);
    useEffect(() => {
        if(hrRef.current)
        hrRef.current.scrollTo({
            top: timeHeight*initHr,
            left: 0,
        });
        if(minRef.current)
            minRef.current.scrollTo({
                top: timeHeight*parseInt(initMin/5),
                left: 0,
            });
    }, [])
    useEffect(() => {
        onSelect({ hr, min });
    }, [hr, min])
    return (
        <div className={style.timePicker}>
            <div className={style.hour} ref={hrRef} style={{ height: `${(timeHeight * 7)}px` }} onScroll={e => {
                let ind = Math.floor(e.target.scrollTop / timeHeight);
                if(ind<0)
                    ind=0;
                else if(ind>hours.length-1)
                {
                    ind=hours.length-1;
                }
                set_hr(hours[ind]);
                onChangedHr(hours[ind]);
            }}>
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                {hours.map((hr, k) => {
                    return <TimeDiv height={timeHeight} key={k}>
                        <YStyled.Span size={22} fontWeight={400}>{hr}</YStyled.Span>
                    </TimeDiv>
                })}
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
            </div>
            <div className={style.min} ref={minRef} style={{ height: `${(timeHeight * 7)}px` }} onScroll={e => {
                let ind = Math.floor(e.target.scrollTop / timeHeight);
                if(ind<0)
                    ind=0;
                else if(ind>minutes.length-1)
                {
                    ind=minutes.length-1;
                }
                set_min(minutes[ind]);
                onChangedMin(minutes[ind]);
            }}>
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                {minutes.map((min, k) => {
                    return <TimeDiv height={timeHeight} key={k}>
                        <YStyled.Span size={22} fontWeight={400}>{min}</YStyled.Span>
                    </TimeDiv>
                })}
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
            </div>
            <div className={style.mask}></div>
        </div>
    );
}

export default SelectTime;